var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36 2.286a3.11 3.11 0 00-2.152.85l-1.158 1.1a1.244 1.244 0 01-1.699 0 1.107 1.107 0 010-1.618l1.159-1.1A5.596 5.596 0 015.36 0c3.003 0 5.44 2.321 5.44 5.182a5.06 5.06 0 01-1.593 3.664L4.1 13.714h6.7c.663 0 1.199.511 1.199 1.143S11.464 16 10.8 16H1.203c-.484 0-.923-.279-1.11-.707a1.105 1.105 0 01.258-1.247L7.51 7.232c.57-.543.892-1.282.892-2.05 0-1.6-1.361-2.896-3.04-2.896z",
    fill: "#00B9EF"
  })));
}

export default SvgTwo;